import { ButtonBase, styled } from '@mui/material';

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: theme.spacing(0.5),
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider[7]}`,
  '& .EARCImgContainer': {
    height: theme.typography.pxToRem(380),
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(300),
    },
    '& .IBimg': {
      transition: 'transform 0.4s ease-in-out',
    },
  },
  '& .EARCFeatured': {
    position: 'absolute',
    zIndex: 2,
    top: theme.spacing(2),
    right: theme.spacing(2),
    padding: theme.spacing(0.5, 0.75),
    borderRadius: theme.spacing(0.5),
    color: theme.palette.common.black,
    height: 'auto',
    '& .MuiChip-label': {
      fontWeight: 600,
      textTransform: 'uppercase',
      position: 'relative',
      top: theme.spacing(0.25),
      lineHeight: theme.spacing(1.75),
      paddingLeft: theme.spacing(0.5),
      paddingRight: 0,
    },
    '& .MuiChip-icon': {
      fontSize: theme.spacing(1.75),
      marginLeft: 0,
      marginRight: 0,
    },
  },
  '& .ERCContent': {
    padding: theme.spacing(4, 3, 2, 3),
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 2, 1, 2),
      display: 'block',
    },
  },
  '& .ERCTitleMobileContainer': {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      gap: theme.spacing(3),
      alignItems: 'center',
    },
  },
  '& .ERCStartDate': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.5, 2, 1, 2),
    backgroundColor: theme.palette.common.fogWhite,
    color: theme.palette.common.black,
    textTransform: 'uppercase',
    height: 'fit-content',
    '&.showTabletAndDesktop': {
      [theme.breakpoints.down('md')]: {
        display: 'none !important',
      },
    },
    '&.showMOBILE': {
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  },
  '& .ERCMonth': {
    lineHeight: theme.spacing(2),
    fontSize: theme.spacing(1.75),
  },
  '& .ERCDay': {
    fontWeight: 900,
    lineHeight: theme.spacing(3),
    fontSize: theme.spacing(2.5),
  },
  '& .ERCInfoItem': {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
  },

  '& .ERCInfoIcon': {
    position: 'relative',
    top: theme.typography.pxToRem(1),
    fontSize: theme.spacing(2.25),
  },
  '& .ERCBtn': {
    paddingLeft: 0,
    paddingRight: 0,
    marginTop: 'auto',
    fontSize: theme.spacing(2),
    textTransform: 'none',
  },
  '& .ERCLeftSideContent': {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(2.5),
    flexDirection: 'column',
    alignItems: 'flex-start',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  '& .ERCBtnContainer': {
    flex: 1,
    display: 'flex',
    alignItems: 'end',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },
  '&:hover': {
    '& .ERCBtn': {
      color: theme.palette.primary.main,
    },
    '& .IBimg': {
      transform: 'scale(1.05)',
    },
  },
  '& .ERDescription': {
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default StyledButtonBase;
